"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotorVehicleControlVCToJSON = exports.MotorVehicleControlVCFromJSONTyped = exports.MotorVehicleControlVCFromJSON = exports.instanceOfMotorVehicleControlVC = void 0;
/**
 * Check if a given object implements the MotorVehicleControlVC interface.
 */
function instanceOfMotorVehicleControlVC(value) {
    return true;
}
exports.instanceOfMotorVehicleControlVC = instanceOfMotorVehicleControlVC;
function MotorVehicleControlVCFromJSON(json) {
    return MotorVehicleControlVCFromJSONTyped(json, false);
}
exports.MotorVehicleControlVCFromJSON = MotorVehicleControlVCFromJSON;
function MotorVehicleControlVCFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'vehicle_identification_number_01': json['vehicle_identification_number_01'] == null ? undefined : json['vehicle_identification_number_01'],
        'vehicle_deck_position_code_02': json['vehicle_deck_position_code_02'] == null ? undefined : json['vehicle_deck_position_code_02'],
        'vehicle_type_code_03': json['vehicle_type_code_03'] == null ? undefined : json['vehicle_type_code_03'],
        'dealer_code_04': json['dealer_code_04'] == null ? undefined : json['dealer_code_04'],
        'route_code_05': json['route_code_05'] == null ? undefined : json['route_code_05'],
        'bay_location_06': json['bay_location_06'] == null ? undefined : json['bay_location_06'],
        'automotive_manufacturers_code_07': json['automotive_manufacturers_code_07'] == null ? undefined : json['automotive_manufacturers_code_07'],
        'damage_exception_indicator_code_08': json['damage_exception_indicator_code_08'] == null ? undefined : json['damage_exception_indicator_code_08'],
        'supplemental_inspection_code_09': json['supplemental_inspection_code_09'] == null ? undefined : json['supplemental_inspection_code_09'],
        'factory_car_order_number_10': json['factory_car_order_number_10'] == null ? undefined : json['factory_car_order_number_10'],
        'vessel_stowage_location_11': json['vessel_stowage_location_11'] == null ? undefined : json['vessel_stowage_location_11'],
        'equipment_orientation_code_12': json['equipment_orientation_code_12'] == null ? undefined : json['equipment_orientation_code_12'],
        'location_identifier_13': json['location_identifier_13'] == null ? undefined : json['location_identifier_13'],
    };
}
exports.MotorVehicleControlVCFromJSONTyped = MotorVehicleControlVCFromJSONTyped;
function MotorVehicleControlVCToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'vehicle_identification_number_01': value['vehicle_identification_number_01'],
        'vehicle_deck_position_code_02': value['vehicle_deck_position_code_02'],
        'vehicle_type_code_03': value['vehicle_type_code_03'],
        'dealer_code_04': value['dealer_code_04'],
        'route_code_05': value['route_code_05'],
        'bay_location_06': value['bay_location_06'],
        'automotive_manufacturers_code_07': value['automotive_manufacturers_code_07'],
        'damage_exception_indicator_code_08': value['damage_exception_indicator_code_08'],
        'supplemental_inspection_code_09': value['supplemental_inspection_code_09'],
        'factory_car_order_number_10': value['factory_car_order_number_10'],
        'vessel_stowage_location_11': value['vessel_stowage_location_11'],
        'equipment_orientation_code_12': value['equipment_orientation_code_12'],
        'location_identifier_13': value['location_identifier_13'],
    };
}
exports.MotorVehicleControlVCToJSON = MotorVehicleControlVCToJSON;
